// Encounter.period.end, held to the FHIR invariant that a period cannot end before it starts.
//
// per-1 (`start.hasValue().not() or end.hasValue().not() or (start <= end)`) is enforced by
// Aidbox, which answers a violating write with 422 and drops it. The write is the last step of
// finishing a form or a visit, so a rejected one leaves the record stuck in progress (#5945).

// The end to stamp on an Encounter.period: `end`, or `start` when `end` would fall earlier or at the same instant.
// Clamping yields a zero-length period rather than moving the start, which would rewrite when the visit began. An
// unparseable start or end can't be compared, so `end` is returned untouched; `end` defaults to now.
export function encounterPeriodEnd(start, end = new Date().toISOString()) {
    const startMs = Date.parse(start);
    const endMs = Date.parse(end);

    if (Number.isNaN(startMs) || Number.isNaN(endMs)) return end;

    return endMs <= startMs ? start : end;
}

// `end`, or `start` verbatim when the two are the same instant. Aidbox fails per-1 on an equal start and end written
// in different offsets (a UTC start and a locally edited end), so an equal pair has to be written as one string.
export function sameInstantEnd(start, end) {
    return end && Date.parse(start) === Date.parse(end) ? start : end;
}
